import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Bot, CheckCircle2 } from "lucide-react";

// Task generati dal CRM (db.tasks): rinnovi, richiami, follow-up visite, pratiche ferme… dell'agente titolare.
export default function TaskCrm() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [list, setList] = useState(null);
  const load = () => api.get("/tasks").then((r) => setList((r.data || []).filter((t) => t.owner_agent_id === user?.id))).catch(() => setList([]));
  useEffect(() => { load(); }, [user?.id]); // eslint-disable-line
  if (!list || !list.length) return null;
  const oggi = new Date().toISOString().slice(0, 10);
  const fatto = async (t) => {
    if (t.tipo === "piano_azione_fermo" && link(t)) { toast.message("Per chiudere questo task compila il piano d'azione nella scheda immobile"); nav(link(t)); return; }
    setList((a) => a.filter((x) => x.id !== t.id));
    try { await api.put(`/tasks/${t.id}`, { stato: "completato" }); toast.success("Task completato"); }
    catch (e) { toast.error(apiError(e)); load(); }
  };
  const link = (t) => (t.immobile_id ? `/immobili/${t.immobile_id}` : t.notizia_id ? `/notizie/${t.notizia_id}` : null);
  return (
    <div className="card-immo p-4 mb-6" data-testid="task-crm">
      <div className="flex items-center gap-2 mb-2"><Bot size={16} className="text-[#FC82ED]" /><h2 className="font-display font-bold text-sm">Promemoria del CRM</h2>
        <span className="ml-auto text-xs font-bold px-2 py-0.5 rounded-full bg-[#FC82ED]/15" data-testid="task-crm-n">{list.length}</span></div>
      <div className="space-y-1.5">
        {list.map((t) => {
          const due = String(t.due_date || "").slice(0, 10);
          return (
            <div key={t.id} data-testid={`task-crm-${t.id}`} className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-[#F7F7F8]">
              <button data-testid={`task-crm-fatto-${t.id}`} onClick={() => fatto(t)} title="Segna come fatto" className="text-slate-400 hover:text-emerald-600"><CheckCircle2 size={17} /></button>
              <button onClick={() => link(t) && nav(link(t))} className="flex-1 min-w-0 text-left text-sm truncate">{t.titolo || "Task"}</button>
              {due && <span className={`text-[11px] shrink-0 ${due < oggi ? "text-red-600 font-semibold" : "text-[var(--muted)]"}`}>{due < oggi ? "in ritardo · " : ""}{due}</span>}
            </div>);
        })}
      </div>
    </div>
  );
}
